/* eslint-disable func-names */

export default function MuiGridUtil() { }

/**
 * fields 에 해당하는 각 값을 반환한다.
 * @param {Object} data
 * @param {Array} fields
 */
MuiGridUtil.resolveDataOfFields = function (data, fields) {
  if (data && Object.keys(data).length && fields) {
    const value = {};
    fields.forEach(field => {
      value[field] = data[field];
    });

    return value;
  }
  return null;
};

/**
 * field 에 해당하는 각 값을 반환한다.
 * @param {Object} data
 * @param {String} field
 */
MuiGridUtil.resolveDataOfField = function (data, field) {
  if (data && Object.keys(data).length && field) {
    const value = {};
    value[field] = data[field];

    return value;
  }
  return null;
};

/**
 * 1레벨 Object 에 대해 값이 같은지 여부를 반환한다.
 *
 * @param {Object} sourceObject
 * @param {Object} targetObject
 * @return {Boolean}
 */
MuiGridUtil.isEqualObjectValue = function (sourceObject, targetObject) {
  if (Object.keys(sourceObject).length !== Object.keys(targetObject).length) {
    return false;
  }

  const isEqualObjectValue = Object.keys(sourceObject).every(key => sourceObject[key] === targetObject[key]);

  return isEqualObjectValue;
};
